'use client';
import { createContext, useContext } from 'react';
import { useTranslation as useTranslationClient } from '@/lib/i18n/i18n.client';
import { fallbackLng } from '@/lib/i18n/settings';

const LanguageContext = createContext();

export const useTranslation = (overrideNS, options) => {
  const { lng, ns } = useContext(LanguageContext);
  return useTranslationClient(lng, overrideNS || ns, options);
};

export const useLanguage = () => useContext(LanguageContext);

export default function LanguageProvider({ defaultLng, ns: propNs, children }) {
  const { lng: parentLng, ns: parentNs } = useLanguage() || {};
  const lng = parentLng || defaultLng || fallbackLng;
  const ns = propNs || parentNs;
  return (
    <LanguageContext.Provider value={{ lng, ns }}>
      {children}
    </LanguageContext.Provider>
  );
}
